import styled from "styled-components";

import { Star } from "@ui/Assets/MyIcons";
import { Text } from "@ui/Atoms/Text";

export const Root = styled.div`
  padding: ${props => props.theme.spacing.spacing_24};
  border-radius: 12px;
  background-color: ${props => props.theme.palette.white};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.spacing_24};

  ${props => props.theme.breakpointsV2.smallDesktop} {
    padding: ${props => props.theme.spacing.spacing_32};
  }
`;

export const ScoreBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.spacing_4};

  ${props => props.theme.breakpointsV2.smallTablet} {
    flex-direction: row;
    gap: ${props => props.theme.spacing.spacing_12};
  }
`;

export const ScoreHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spacing.spacing_4};
`;

export const StarsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
`;

interface StarProps {
  $isFilled: boolean;
}

export const StarIcon = styled(Star).attrs<StarProps>(props => ({
  width: props.theme.icons.sizes.base_x3,
  color: props.theme.palette.yellow500,
  fill: props.$isFilled && props.theme.palette.yellow500,
}))<StarProps>``;

export const Content = styled(Text).attrs({
  $style: "semibold_12",
})`
  text-align: center;
`;
